module.exports = __webpack_public_path__ + "static/img/item-2-3-big.603bdbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-2-3-big.png
// module id = tjje
// module chunks = 2